import styled from 'styled-components';

const CourseReportStyle = styled.div`
    // .main_container_box{
    //     height: 100vh;
    // }    
    .user-title-container{
        text-align: left;
    }
    .user-menu-title{
        font-size: 1.424rem;
        font-weight: 700;
        line-height: 1.3;
        margin: 0px;
        word-break: break-word;
        hyphens: auto;
        text-align: left;
        margin-bottom: 10px;
    }
    .users-menu-filter-container{
        display: flex;
        align-items: center;
        gap: 18px;
    }
    .search-input-field{
        margin-bottom: 0px !important;
        input{
            margin-bottom: 0px;
        }
    }
    .add_form_container_box{
        width: 50%;
    }
    .adduser-container{
        display: flex;
        width: 100%;
        height: 100%;
        gap: 30px;
    }
    .upload-img-box{
        width: 200px;
    }
    .form_input_fields{
        .ant-row{
            display: flex;
            flex-direction: column;
        }
        .ant-form-item-label{
            text-align: left;
        }
    }
    .course-overview-data-box{
        display: flex;
        justify-content: space-around;
        padding: 16px 0px;
        background: rgb(245, 245, 246);
    }
    .overview-value{
        font-size: 1.802rem;
        font-weight: 700;
        line-height: 1.3;
        margin: 0px;
    }

    .overview-label{
        font-size: 0.889rem;
        font-weight: 400;
        line-height: 1.3;
        margin: 0px;
    }

    .download_csv_con{
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 6px;
        font-size: 22px;
        width: 30px;
        height: 30px;
        background-color: rgb(245, 245, 246);
        cursor: pointer;
    }
`;

export default CourseReportStyle;